// src/components/Navbar.tsx

import { useState } from "react";

import {
  Menu,
  X
} from "lucide-react";

import logo from "../assets/logo12.png";

import "./Navbar.css";

const Navbar = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  return (

    <header className="navbar-wrapper">

      <nav className="navbar">

        {/* =========================
            LOGO
        ========================= */}

        <a
          href="#home"
          className="logo-side"
        >

          <img
            src={logo}
            alt="Dagda Nutrition"
            className="navbar-logo"
          />

          <h2>
            Dagda
            <span>Nutrition</span>
          </h2>

        </a>

        {/* =========================
            NAV LINKS
        ========================= */}

        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>

          <li>
            <a
              href="#homepage"
              onClick={() => setMenuOpen(false)}
            >
              Home
            </a>
          </li>

          <li>
            <a
              href="#about"
              onClick={() => setMenuOpen(false)}
            >
              About
            </a>
          </li>

          <li>
            <a
              href="#features"
              onClick={() => setMenuOpen(false)}
            >
              Features
            </a>
          </li>

          <li>
            <a
              href="#works"
              onClick={() => setMenuOpen(false)}
            >
              How It Works
            </a>
          </li>

          <li>
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </a>
          </li>

          {/* MOBILE BUTTON */}

          <button className="mobile-btn">
            Get Started
          </button>

        </ul>

        {/* =========================
            DESKTOP BUTTON
        ========================= */}

        <button className="nav-btn">
          Get Started
        </button>

        {/* =========================
            MOBILE MENU
        ========================= */}

        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >

          {
            menuOpen
              ? <X size={26} />
              : <Menu size={26} />
          }

        </button>

      </nav>

    </header>

  );
};

export default Navbar;